import { Button, cn, Stack } from 'component-library';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PlotGroup } from '@/api/rest/resources/types/plotGroup';
import { Icon } from '@/components/widgets/a/Icon/Icon';
import { CreateGroup, EditGroup } from '@/pages/shared/components/plot-group/EditPlotGroup';
import { isNullish } from '@/utils/booleans';

export const CreatePlotGroup = ({
  organizationId,
  plotIds,
  plotGroup,
  disabled = false,
}: {
  organizationId: string;
  plotIds?: string[];
  plotGroup?: PlotGroup;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const [isEditingPlotGroup, setIsEditingPlotGroup] = useState(false);
  const disable = disabled ?? (isNullish(plotIds) && isNullish(plotGroup));
  return (
    <Stack className='flex flex-row justify-end'>
      <Button
        variant='outline'
        onClick={() => setIsEditingPlotGroup(true)}
        disabled={disable}
        leftAdornment={
          <Icon
            icon='ri-gallery-view-2'
            className={cn('w-4 p-0 m-0', disable ? 'text-text-disabled' : 'text-primary-100')}
          />
        }
      >
        {t('global.organization.plotGroup.createPlotGroup.buttonLabel')}
      </Button>
      <CreateGroup
        organizationId={organizationId}
        plotGroup={plotGroup ?? null}
        open={isEditingPlotGroup}
        onOpenChange={(open) => setIsEditingPlotGroup(open)}
        additionalPlots={plotIds}
      />
    </Stack>
  );
};

export const EditPlotGroup = ({
  organizationId,
  plotIds,
  plotGroup,
  disabled = false,
}: {
  organizationId: string;
  plotIds?: string[];
  plotGroup?: PlotGroup;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const [isEditingPlotGroup, setIsEditingPlotGroup] = useState(false);
  const disable = disabled ?? (isNullish(plotIds) && isNullish(plotGroup));
  return (
    <Stack className='flex flex-row justify-end'>
      <Button
        variant='outline'
        onClick={() => setIsEditingPlotGroup(true)}
        disabled={disable}
        leftAdornment={
          <Icon
            icon='ri-gallery-view-2'
            className={cn('w-4 p-0 m-0', disable ? 'text-text-disabled' : 'text-primary-100')}
          />
        }
      >
        {t('global.organization.plotGroup.editGroup.title')}
      </Button>
      <EditGroup
        organizationId={organizationId}
        plotGroup={plotGroup ?? null}
        open={isEditingPlotGroup}
        onOpenChange={(open) => setIsEditingPlotGroup(open)}
        additionalPlots={plotIds}
      />
    </Stack>
  );
};
